import { type FC, type PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";

export const ErrorComponent: FC<PropsWithChildren> = () => {
    return (
        <FormattedMessage id="reviermanager.common.error" defaultMessage="Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal." />
    );
};
